import { useEffect } from "react";

const KeyboardInputFix = () => {
  useEffect(() => {
    const isMobileOrTablet =
      window.innerWidth <= 1024 || 
      /Mobi|Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || 
      /wv|WebView/i.test(navigator.userAgent); 
    if (!isMobileOrTablet) return; 

    const handleFocus = (event) => {
      const input = event.target;

      if (["INPUT", "TEXTAREA", "SELECT"].includes(input.tagName)) {
        setTimeout(() => {
          input.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      }

      // Prevent keyboard on native date inputs or react-datepicker fields
      const isNativeDate = input.type === "date";
      const isReactDatePicker =
        input.classList.contains("react-datepicker-ignore-onclickoutside") ||
        input.dataset.datepicker === "true";

      if (isNativeDate || isReactDatePicker) {
        input.setAttribute("readonly", true);

        if (isNativeDate) {
          input.showPicker?.();
        }
      }
    };

    document.addEventListener("focusin", handleFocus);
    return () => document.removeEventListener("focusin", handleFocus);
  }, []);

  return null;
};

export default KeyboardInputFix;
